import styled from '@emotion/styled'
import React, { useContext } from 'react'

import { LoopContext, ShopifyContext } from '../Layout'
import strings from './strings.json'
import Button from '../shared/Buttons/Button'
import { navigate } from 'gatsby'

const { cartCheckoutButton } = strings

const CheckoutButtonStyled = styled(Button)`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 54px;
  cursor: pointer;
`

const CheckoutButton = ({ url, enabled, variantIds }) => {
  const { clearCart } = useContext(ShopifyContext)
  const { createOrUpdateLoopCart, isLoopCart } = useContext(LoopContext)

  async function navigateToLoop(variantIds) {
    //BLOCKED: {"errors":{"message":"Variant ID Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzYwMjc3MDUwNTczMDkwP2NoZWNrb3V0PWY1OGVkMDc5YWM4MGJkMDZjOTlkZTg1M2VkOTdjMjQ4 not found."},"data":{"cart":["Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzYwMjc3MDUwNTczMDkwP2NoZWNrb3V0PWY1OGVkMDc5YWM4MGJkMDZjOTlkZTg1M2VkOTdjMjQ4"]}}
    await createOrUpdateLoopCart(variantIds, clearCart)
  }

  return (
    <CheckoutButtonStyled
      onClick={() =>
        enabled && (isLoopCart ? navigateToLoop(variantIds) : navigate(url))
      }
      variant="secondary"
      sx={{ width: '100%' }}
      disabled={!enabled}
    >
      {cartCheckoutButton}
    </CheckoutButtonStyled>
  )
}

export default CheckoutButton
